import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Card } from "antd";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { fetchAnalyticsData } from "../../actions/AnalyticsActions";

dayjs.extend(isBetween);

const PageVisits = () => {
  const dispatch = useDispatch();
  const analyticsData = useSelector((state) => state.analytics.visits);
  const [pageStats, setPageStats] = useState([]);

  // useEffect(() => {
  //   dispatch(fetchAnalyticsData());
  // }, [dispatch]);

  useEffect(() => {
    if (analyticsData.length > 0) {
      processAnalyticsData();
    }
  }, [analyticsData]);
  const processAnalyticsData = () => {
    const now = dayjs();
    const startOfToday = now.startOf("day");
    const startOfYesterday = now.subtract(1, "day").startOf("day");
    const startOfWeek = now.startOf("week");
    const startOfLastWeek = now.subtract(1, "week").startOf("week");
    const startOfMonth = now.startOf("month");
    const startOfLastMonth = now.subtract(1, "month").startOf("month");
    const startOfYear = now.startOf("year");
    const startOfLastYear = now.subtract(1, "year").startOf("year");
  
    const pageCounts = {};
    
    // Object to hold unique deviceId sets for each time period
    const uniqueDeviceIds = {
      today: new Set(),
      yesterday: new Set(),
      thisWeek: new Set(),
      lastWeek: new Set(),
      thisMonth: new Set(),
      lastMonth: new Set(),
      thisYear: new Set(),
      lastYear: new Set(),
    };
  
    analyticsData.forEach((log) => {
      const timestamp = dayjs(log.timestamp.seconds * 1000);
      const page = log.page;
      const deviceId = log.deviceId;
  
      if (!pageCounts[page]) {
        pageCounts[page] = {
          page,
          today: 0,
          yesterday: 0,
          thisWeek: 0,
          lastWeek: 0,
          thisMonth: 0,
          lastMonth: 0,
          thisYear: 0,
          lastYear: 0,
        };
      }
  
      // Update counts for each time period
      if (timestamp.isAfter(startOfToday)) {
        pageCounts[page].today++;
        uniqueDeviceIds.today.add(deviceId); // Unique devices today
      } else if (timestamp.isBetween(startOfYesterday, startOfToday)) {
        pageCounts[page].yesterday++;
        uniqueDeviceIds.yesterday.add(deviceId); // Unique devices yesterday
      }
  
      if (timestamp.isAfter(startOfWeek)) {
        pageCounts[page].thisWeek++;
        uniqueDeviceIds.thisWeek.add(deviceId); // Unique devices this week
      } else if (timestamp.isBetween(startOfLastWeek, startOfWeek)) {
        pageCounts[page].lastWeek++;
        uniqueDeviceIds.lastWeek.add(deviceId); // Unique devices last week
      }
  
      if (timestamp.isAfter(startOfMonth)) {
        pageCounts[page].thisMonth++;
        uniqueDeviceIds.thisMonth.add(deviceId); // Unique devices this month
      } else if (timestamp.isBetween(startOfLastMonth, startOfMonth)) {
        pageCounts[page].lastMonth++;
        uniqueDeviceIds.lastMonth.add(deviceId); // Unique devices last month
      }
  
      if (timestamp.isAfter(startOfYear)) {
        pageCounts[page].thisYear++;
        uniqueDeviceIds.thisYear.add(deviceId); // Unique devices this year
      } else if (timestamp.isBetween(startOfLastYear, startOfYear)) {
        pageCounts[page].lastYear++;
        uniqueDeviceIds.lastYear.add(deviceId); // Unique devices last year
      }
    });
  
    // Compute total visits
    const totalVisits = {
      page: "Total Visits",
      today: 0,
      yesterday: 0,
      thisWeek: 0,
      lastWeek: 0,
      thisMonth: 0,
      lastMonth: 0,
      thisYear: 0,
      lastYear: 0,
    };
  
    Object.values(pageCounts).forEach((counts) => {
      totalVisits.today += counts.today;
      totalVisits.yesterday += counts.yesterday;
      totalVisits.thisWeek += counts.thisWeek;
      totalVisits.lastWeek += counts.lastWeek;
      totalVisits.thisMonth += counts.thisMonth;
      totalVisits.lastMonth += counts.lastMonth;
      totalVisits.thisYear += counts.thisYear;
      totalVisits.lastYear += counts.lastYear;
    });
  
    // Unique Visits count
    const uniqueVisits = {
      page: "Unique Visits",
      today: uniqueDeviceIds.today.size, // Unique devices today
      yesterday: uniqueDeviceIds.yesterday.size, // Unique devices yesterday
      thisWeek: uniqueDeviceIds.thisWeek.size, // Unique devices this week
      lastWeek: uniqueDeviceIds.lastWeek.size, // Unique devices last week
      thisMonth: uniqueDeviceIds.thisMonth.size, // Unique devices this month
      lastMonth: uniqueDeviceIds.lastMonth.size, // Unique devices last month
      thisYear: uniqueDeviceIds.thisYear.size, // Unique devices this year
      lastYear: uniqueDeviceIds.lastYear.size, // Unique devices last year
    };
  
    setPageStats([...Object.values(pageCounts), totalVisits, uniqueVisits]);
  };
  
  const columns = [
    { title: "Page", dataIndex: "page", key: "page" },
    { title: "Today", dataIndex: "today", key: "today" },
    { title: "Yesterday", dataIndex: "yesterday", key: "yesterday" },
    { title: "This Week", dataIndex: "thisWeek", key: "thisWeek" },
    { title: "Last Week", dataIndex: "lastWeek", key: "lastWeek" },
    { title: "This Month", dataIndex: "thisMonth", key: "thisMonth" },
    { title: "Last Month", dataIndex: "lastMonth", key: "lastMonth" },
    { title: "This Year", dataIndex: "thisYear", key: "thisYear" },
    { title: "Last Year", dataIndex: "lastYear", key: "lastYear" },
  ];

  return (
    <Card title="Page Visits Analytics">
      <Table
       columns={columns}
       dataSource={pageStats}
       rowKey="page" 
      pagination={false}
       size="small"
       scroll={{
        x: 'max-content',
      }}
      />
    </Card>
  );
};

export default PageVisits;
